import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'

export default create(
  persist(
    (set, get) => ({
      partnerUserConfig: {},
      setPartnerUserConfig: (partnerUserConfig) => set({ partnerUserConfig })
    }),
    {
      name: 'session-store',
      storage: createJSONStorage(() => sessionStorage)
    }
  )
)
